// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const AdditionalAntennaRow = ({ antennaCode, modelNumber, centerline, idRoot }) => (
  <dd className={'additional-tooltip-separator'}>
    <ul>
      <li>
        <span id={`${idRoot}code-label`}>{'CODE'}</span>
        <span id={`${idRoot}code-value`}>{antennaCode}</span>
      </li>
      <li>
        <span id={`${idRoot}model-label`}>{'MODEL'}</span>
        <span id={`${idRoot}model-value`}>{modelNumber}</span>
      </li>
      <li>
        <span id={`${idRoot}centerline-label`}>{'CENTERLINE'}</span>
        <span id={`${idRoot}centerline-value`}>{centerline}</span>
      </li>
    </ul>
  </dd>
)

AdditionalAntennaRow.propTypes = {
  antennaCode: string.isRequired,
  centerline: string.isRequired,
  idRoot: string.isRequired,
  modelNumber: string.isRequired,
}

export default AdditionalAntennaRow
